import { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "./BreadCrumbs";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Checkbox,
  TextField,
  Typography,
  useMediaQuery,
  Stack,
  Tooltip,
  IconButton,
} from "@mui/material";
import moment from "moment";
import {
  CmpDatePickerField001V1,
  CmpTextFieldEnterV1,
} from "../../Component/Common/ToolBox/ToolBoxV1";
import "./StockSetupChangeRequest.css";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import FilterModal from "./FilterModal";
import {
  ISTCR_Items_Master_GetRow,
  ISTCRA_ISTCRB_Delete,
  ISTCRA_ISTCRB_Update,
  ISTCRA_REVERSE,
  ISTCRB_Getrow,
  ISTCR_Reason_Getrow,
} from "../../Server/ApiV2";
import { StockSetupChangeRequestRo, vRdxUserInfo } from "../../Redux/roStore";
import { Head_Set } from "./SliceStockSetupChangeRequest";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import { getGlobals } from "../../Configs";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { confirmAlert } from "react-confirm-alert";
import { fExecuteAPI } from "../../Server/Apis";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import FieldGroupComp from "./processComponent/FieldGroup";

const StockSetupChangeRequestDetail = () => {
  const apiRef = useGridApiRef();

  const baseURL = getGlobals().API_BASE_URL;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [reasonAttributes, setReasonAttributes] = useState({});

  const vMediaQuery = useMediaQuery("(max-width:400px)");
  const transObj = useSelector(
    (state) => state.SliceStockSetupChangeRequest.value.Head
  );

  const vRdxKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const lpoGroupDropDown = useSelector(
    (state) => state.SliceDB.value.LPO_GROUP
  );

  const isVisible = vRdxKernObj?.STOCK_SETUP_MAX_FIELD?.Val === "Y";
  const [DetailData, setDetailData] = useState([]); // DetailData

  //Location
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const HeadObject = StockSetupChangeRequestRo();

  useEffect(() => {
    fLoadDetail();
  }, []);

  const fLoadDetail = async (transid = "", isNewBtnClick = false) => {
    const obj = {
      B_Transid: isNewBtnClick ? "" : transObj?.A_Transid || transid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const detailRes = await ISTCRB_Getrow(FinalObj);
    if (detailRes?.status === 200) {
      setDetailData(detailRes?.data?.ResultSet);
    }
  };

  // CheckBoxes and Edit Fields
  const initialBufferObj = {
    B_Transid: "",
    B_Srno: 0,
    B_Itmcd: "",
    ItemName: "",
    Old_DisContinued: "N",
    New_DisContinued: "N",
    Old_ItActive: "Y",
    New_ItActive: "Y",
    Old_DCDisCon: "N",
    New_DCDisCon: "N",
    Old_CNTRLPUR: "N",
    New_CNTRLPUR: "N",
    Old_LCLPur: "N",
    New_LCLPur: "N",
    Old_MinStockDays: 0,
    New_MinStockDays: 0,
    Old_SafetyStockDays: 0,
    New_SafetyStockDays: 0,
    Old_MaxStockDays: 0,
    New_MaxStockDays: 0,
    Old_ShelfQty: 0,
    New_ShelfQty: 0,
    Old_ShelfQty2: 0,
    New_ShelfQty2: 0,
    RejectDetail: "",
    B_RejectDetail: "",
    B_ReJectNarration: "",
    DisContinue_Reason: "",
    DisContinue_ReasonName: "",
    Active_Reason: "",
    Active_ReasonName: "",
    DCDisCon_Reason: "",
    DCDisCon_ReasonName: "",
    CNTRLPUR_Reason: "",
    CNTRLPUR_ReasonName: "",
    LCLPur_Reason: "",
    LCLPUR_ReasonName: "",
    ShelfQty_Reason: "",
    ShelfQty_ReasonName: "",
    StockDays_Reason: "",
    StockDays_ReasonName: "",
  };

  const [bufferObject, setBufferObj] = useState(initialBufferObj);

  const getCyclicCountItemGetRow = async (ItmCd) => {
    const HeadObject = StockSetupChangeRequestRo();

    let date1 = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    let date2 = new Date();
    const obj = {
      v_MainGrp: "",
      v_SubGrp: "",
      v_Grp: "",
      v_BrandCd: "",
      v_Supplier: "",
      v_Loc: HeadObject?.Head?.A_Location,
      v_Date1: moment(date1).format("MM/DD/YYYY"),
      v_Date2: moment(date2).format("MM/DD/YYYY"),
      v_DCItemsOnly: "B",
      v_ItmCd: ItmCd,
    };

    if (HeadObject?.Head?.A_Location === "") {
      fAlertToast("INFO", "Location should not be empty");
      return;
    }

    if (date1 === "") {
      fAlertToast("INFO", "Date1 should not be empty");
      return;
    }

    if (date2 === "") {
      fAlertToast("INFO", "Date2 should not be empty");
      return;
    }

    if (ItmCd === "") {
      fAlertToast("INFO", "ItemCode should not be empty");
      return;
    }

    const response = await ISTCR_Items_Master_GetRow(obj);

    if (response?.status === 200) {
      const resultset = response?.data?.ResultSet;

      setBufferObj((prevV) => ({
        ...prevV,
        ...resultset[0],
      }));
    }
  };

  const handleDetailChange = (field, value, event = null) => {
    setBufferObj((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  useEffect(() => {
    const handleClick = (event) => {
      // For item name toggle
      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  useEffect(() => {
    getReasonAttribute();
  }, []);
  const getReasonAttribute = async () => {
    try {
      const res = await ISTCR_Reason_Getrow();
      if (res?.status === 200) {
        setReasonAttributes(res?.data?.ResultSet || {});
        console.log(res?.data?.ResultSet);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleItemSelection = async (ItmCd, Name1) => {
    setBufferObj((prev) => ({
      ...prev,
      B_Itmcd: ItmCd,
      ItemName: Name1,
    }));
    getCyclicCountItemGetRow(ItmCd);
  };

  const handleChange = (field, value, type = "text") => {
    setBufferObj((prev) => {
      const next = { ...prev, [field]: value };
      // 3️⃣ Maintain the invariant: Max = Min + Safety
      if (field === "New_MinStockDays" || field === "New_SafetyStockDays") {
        const min = +next.New_MinStockDays || 0;
        const safety = +next.New_SafetyStockDays || 0;
        next.New_MaxStockDays = min + safety;
      } else if (field === "New_MaxStockDays") {
        // If Max is changed, we can choose to update Safety (or Min, depending on business logic)
        const min = +next.New_MinStockDays || 0;
        const max = +value || 0;
        next.New_SafetyStockDays = max - min;
      }
      return next; // 🔑 Don’t forget to return!
    });
  };

  const handleRowClick = (selectedRow) => {
    setBufferObj((prevV) => ({
      ...prevV,
      ...selectedRow,
    }));
  };

  const fValidationHead = () => {
    const HeadObject = StockSetupChangeRequestRo();
    let isValid = true;
    if (HeadObject?.Head?.A_Transid === "") {
      fAlertToast("FAILED", "Trans Id should not be empty");
      isValid = false;
      return;
    }
    if (HeadObject?.Head?.A_Date === "") {
      fAlertToast("FAILED", "Date should not be empty");
      isValid = false;
      return;
    }
    if (HeadObject?.Head?.A_Location === "") {
      fAlertToast("FAILED", "Location should not be empty");
      isValid = false;
      return;
    }
  if (HeadObject?.Head?.LPOGruppen === "") {
      fAlertToast("FAILED", "LPOGruppen should not be empty");
      isValid = false;
      return;
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    if (
      bufferObject.B_Itmcd === "" ||
      bufferObject.B_Itmcd == undefined ||
      bufferObject.B_Itmcd === null
    ) {
      fAlertToast("FAILED", "Item Code is required.");
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_DisContinued === "" ||
      bufferObject.Old_DisContinued === undefined ||
      bufferObject.Old_DisContinued === null
    ) {
      fAlertToast("FAILED", `Old_DisContinued is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_DisContinued === "" ||
      bufferObject.New_DisContinued === undefined ||
      bufferObject.New_DisContinued === null
    ) {
      fAlertToast("FAILED", `New_DisContinued is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_ItActive === "" ||
      bufferObject.Old_ItActive === undefined ||
      bufferObject.Old_ItActive === null
    ) {
      fAlertToast("FAILED", `Old_ItActive is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_ItActive === "" ||
      bufferObject.New_ItActive === undefined ||
      bufferObject.New_ItActive === null
    ) {
      fAlertToast("FAILED", `New_ItActive is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_DCDisCon === "" ||
      bufferObject.Old_DCDisCon === undefined ||
      bufferObject.Old_DCDisCon === null
    ) {
      fAlertToast("FAILED", `Old_DCDisCon is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_DCDisCon === "" ||
      bufferObject.New_DCDisCon === undefined ||
      bufferObject.New_DCDisCon === null
    ) {
      fAlertToast("FAILED", `New_DCDisCon is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_CNTRLPUR === "" ||
      bufferObject.Old_CNTRLPUR === undefined ||
      bufferObject.Old_CNTRLPUR === null
    ) {
      fAlertToast("FAILED", `Old_CNTRLPUR is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_CNTRLPUR === "" ||
      bufferObject.New_CNTRLPUR === undefined ||
      bufferObject.New_CNTRLPUR === null
    ) {
      fAlertToast("FAILED", `New_CNTRLPUR is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_LCLPur === "" ||
      bufferObject.Old_LCLPur === undefined ||
      bufferObject.Old_LCLPur === null
    ) {
      fAlertToast("FAILED", `Old_LCLPur is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_LCLPur === "" ||
      bufferObject.New_LCLPur === undefined ||
      bufferObject.New_LCLPur === null
    ) {
      fAlertToast("FAILED", `New_LCLPur is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_MinStockDays === "" ||
      bufferObject.Old_MinStockDays === undefined ||
      bufferObject.Old_MinStockDays === null
    ) {
      fAlertToast("FAILED", `Old_MinStockDays is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_MinStockDays === "" ||
      bufferObject.New_MinStockDays === undefined ||
      bufferObject.New_MinStockDays === null
    ) {
      fAlertToast("FAILED", `New_MinStockDays is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_SafetyStockDays === "" ||
      bufferObject.Old_SafetyStockDays === undefined ||
      bufferObject.Old_SafetyStockDays === null
    ) {
      fAlertToast("FAILED", `Old_SafetyStockDays is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_SafetyStockDays === "" ||
      bufferObject.New_SafetyStockDays === undefined ||
      bufferObject.New_SafetyStockDays === null
    ) {
      fAlertToast("FAILED", `New_SafetyStockDays is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_MaxStockDays === "" ||
      bufferObject.Old_MaxStockDays === undefined ||
      bufferObject.Old_MaxStockDays === null
    ) {
      fAlertToast("FAILED", `Old_MaxStockDays is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_MaxStockDays === "" ||
      bufferObject.New_MaxStockDays === undefined ||
      bufferObject.New_MaxStockDays === null
    ) {
      fAlertToast("FAILED", `New_MaxStockDays is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_ShelfQty === "" ||
      bufferObject.Old_ShelfQty === undefined ||
      bufferObject.Old_ShelfQty === null
    ) {
      fAlertToast("FAILED", `Old_ShelfQty is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_ShelfQty === "" ||
      bufferObject.New_ShelfQty === undefined ||
      bufferObject.New_ShelfQty === null
    ) {
      fAlertToast("FAILED", `New_ShelfQty is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_ShelfQty2 === "" ||
      bufferObject.Old_ShelfQty2 === undefined ||
      bufferObject.Old_ShelfQty2 === null
    ) {
      fAlertToast("FAILED", `Old_ShelfQty2 is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_ShelfQty2 === "" ||
      bufferObject.New_ShelfQty2 === undefined ||
      bufferObject.New_ShelfQty2 === null
    ) {
      fAlertToast("FAILED", `New_ShelfQty2 is required `);
      isValid = false;
      return;
    }

    return isValid;
  };

  const fSave = async (isApproved, name) => {
    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;
    let items;
    if (!isApproved) {
      //save validation
      if (!fValidationDetail()) return;
     
    if (
      !bufferObject?.DisContinue_Reason
    ) {
      fAlertToast("FAILED", "Discontinue Reason is mandatory");
      return;
    }
     if (
      !bufferObject?.Active_Reason
    ) {
      fAlertToast("FAILED", "Active Reason is mandatory");
      return;
    }
     if (
      !bufferObject?.ShelfQty_Reason
    ) {
      fAlertToast("FAILED", " Shelf Qty Reason is mandatory");
      return;
    }

      // min max validation
      if (
        parseInt(bufferObject?.New_ShelfQty2) >
        parseInt(bufferObject?.New_ShelfQty)
      ) {
        fAlertToast(
          "FAILED",
          "Min shelf qty should not greater than max shelf qty"
        );
        return;
      }
      items = [bufferObject];
    } else {
      if (DetailData?.length === 0) {
        fAlertToast("INFO", `Save atleast one line item`);
        return;
      }
      items = DetailData;
    }

    const vRdxUserInfoObj = vRdxUserInfo();

    const HeadObject = StockSetupChangeRequestRo();
    var obj = {
      A_TransId: HeadObject.Head.A_Transid,
      A_Date: moment(HeadObject.Head.A_Date).format("MM/DD/YYYY"),
      A_Loc: HeadObject.Head.A_Location,
      A_Narration: HeadObject.Head.A_Narration,
      A_UserCd: vRdxUserInfoObj.UserID,
      DeleteInsert: "N",
      Items: items,
      isApproved: isApproved,
      A_LOPGruppen: HeadObject?.Head?.LPOGruppen,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const StockResponse = await ISTCRA_ISTCRB_Update(FinalObj);
    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", `${name}  Successfully`);
      dispatch(
        Head_Set({
          ...transObj,
          A_Transid: StockResponse?.data?.ResultSet[0]?.A_Transid,
          A_Status: name === "Approved" ? "POST" : transObj.A_Status,
          ApproveStatus: "ENTER",
        })
      );
      fNewDetail(StockResponse?.data?.ResultSet[0]?.A_Transid);
    }
  };

  const reverseSave = async () => {
    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;

    const HeadObject = StockSetupChangeRequestRo();
    const obj = {
      //HeadObject?.Head?.A_Transid
      A_TransId: HeadObject?.Head?.A_Transid || 0,
      UserCd: vRdxUserInfo()?.UserID,
      Type: "",
    };
    const reverseRes = await ISTCRA_REVERSE(obj);
    if (reverseRes?.status === 200) {
      dispatch(
        Head_Set({
          ...transObj,
          A_Status: "ENTER",
          A_Status_CM: "ENTER",
        })
      );
      fAlertToast("SUCCESS", "Reversed Successfully");
    } else {
      fAlertToast("FAILED", "Reverse Failed");
    }
  };
  const fNewHead = () => {
    dispatch(
      Head_Set({
        A_Transid: 0,
        A_Date: new Date(),
        A_Location: vRdxuserLoc[0]?.Uid,
        Loc_Name: "",
        A_Narration: "",
        A_Status: "ENTER",
        CreatedBy: "",
        CreatedDate: "",
        ApproveStatus: "ENTER",
        ApprovedBy: "",
        ApproveDt: "",
      })
    );
    fNewDetail("", true);
    setTimeout(() => {
      document.getElementsByName("A_Narration")[0]?.focus();
    }, 500);
  };
  const fNewDetail = async (id = "", isNewBtnClick = false) => {
    setBufferObj(initialBufferObj);
    await fLoadDetail(id, isNewBtnClick);
    setTimeout(() => {
      document.getElementsByName("ItemName")[0]?.focus();
    }, 500);
  };

  const handleDelete = async (row) => {
    const vRdxUserInfoObj = vRdxUserInfo();

    if (row?.B_Transid === "") {
      fAlertToast("INFO", "Trans Id should not be empty");
      return;
    }
    if (row?.B_Srno === "") {
      fAlertToast("INFO", "SrNo should not be empty");
      return;
    }
    if (row?.B_Itmcd === "") {
      fAlertToast("INFO", "ItemCode should not be empty");
      return;
    }

    var obj = {
      A_Transid: row?.B_Transid,
      B_Srno: row?.B_Srno,
      UserCd: vRdxUserInfoObj?.UserID,
      B_Itmcd: row?.B_Itmcd,
    };

    const transDelete = await ISTCRA_ISTCRB_Delete(obj);
    if (transDelete?.status === 200) {
      fAlertToast("SUCCESS", "Deleted Successfully");
      fNewDetail(row?.B_Transid);
    }
  };

  const baseColumns = [
    {
      field: "Transid",
      headerName: "Trans ID",
      width: 90,
      align: "center",
      hide: true,
    },
    {
      field: "RowId",
      headerName: "Sr No",
      width: 60,
      align: "center",
      type: "number",
    },
    {
      field: "delete",
      headerName: "Action",
      width: 70,
      align: "center",
      renderCell: (params) => (
        <DeleteIcon
          style={{
            cursor: transObj?.A_Status === "POST" ? "not-allowed" : "pointer",
            color: transObj?.A_Status === "POST" ? "gray" : "red",
          }}
          disabled={transObj?.A_Status === "POST"}
          onClick={() => {
            if (!(transObj?.A_Status === "POST")) {
              confirmAlert({
                title: "Delete",
                message: `Are you sure you want to delete this item ? ${params.row.ItemName}`,
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => {
                      handleDelete(params.row);
                    },
                  },
                  {
                    label: "No",
                    onClick: () => {},
                  },
                ],
              });
            }
          }}
        />
      ),
      hide: HeadObject?.Head?.A_Status?.toUpperCase() === "POST" ? true : false,
    },
    { field: "B_Itmcd", headerName: "Item Code", width: 90 },
    {
      field: "ItemName",
      headerName: "Item Name",
      width: 300,
      align: "left",
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            lineHeight: "1.4em",
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      field: "Old_DisContinued",
      headerName: "Old",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_DisContinued !== params.row.New_DisContinued
          ? "cell-old"
          : "",
    },
    {
      field: "New_DisContinued",
      headerName: "New",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_DisContinued !== params.row.New_DisContinued
          ? "cell-new"
          : "",
    },
    {
      field: "DisContinue_ReasonName",
      headerName: "Reason",
      width: 90,
      align: "center",
    },
    {
      field: "Old_ItActive",
      headerName: "Old",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_ItActive !== params.row.New_ItActive ? "cell-old" : "",
    },
    {
      field: "New_ItActive",
      headerName: "New",
      width: 60,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_ItActive !== params.row.New_ItActive ? "cell-new" : "",
    },
    {
      field: "Active_ReasonName",
      headerName: "Reason",
      width: 90,
      align: "center",
    },
    {
      field: "Old_ShelfQty",
      headerName: "Old",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_ShelfQty !== params.row.New_ShelfQty ? "cell-old" : "",
    },
    {
      field: "New_ShelfQty",
      headerName: "New",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_ShelfQty !== params.row.New_ShelfQty ? "cell-new" : "",
    },

    {
      field: "Old_ShelfQty2",
      headerName: "Old",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_ShelfQty2 !== params.row.New_ShelfQty2 ? "cell-old" : "",
    },
    {
      field: "New_ShelfQty2",
      headerName: "New",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_ShelfQty2 !== params.row.New_ShelfQty2 ? "cell-new" : "",
    },

    {
      field: "ShelfQty_ReasonName",
      headerName: "Shelf Qty Reason",
      width: 145,
    },
    {
      field: "RejectDetailName",
      headerName: "Reject Type ",
      width: 145,
    },
    {
      field: "B_ReJectNarration",
      headerName: "Reject Narration ",
      width: 115,
    },
  ];

  const maxFieldColumns = [
    {
      field: "Old_DCDisCon",
      headerName: "Old",
      width: 70,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_DCDisCon !== params.row.New_DCDisCon ? "cell-old" : "",
    },
    {
      field: "New_DCDisCon",
      headerName: "New",
      width: 70,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_DCDisCon !== params.row.New_DCDisCon ? "cell-new" : "",
    },
    {
      field: "DCDisCon_ReasonName",
      headerName: "Reason",
      width: 70,
      align: "center",
    },

    {
      field: "Old_CNTRLPUR",
      headerName: "Old",
      width: 70,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_CNTRLPUR !== params.row.New_CNTRLPUR ? "cell-old" : "",
    },
    {
      field: "New_CNTRLPUR",
      headerName: "New",
      width: 70,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_CNTRLPUR !== params.row.New_CNTRLPUR ? "cell-new" : "",
    },
    {
      field: "CNTRLPUR_ReasonName",
      headerName: "Reason",
      width: 70,
      align: "center",
    },
    {
      field: "Old_LCLPur",
      headerName: "Old",
      width: 70,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_LCLPur !== params.row.New_LCLPur ? "cell-old" : "",
    },
    {
      field: "New_LCLPur",
      headerName: "New",
      width: 70,
      align: "center",
      cellClassName: (params) =>
        params.row.Old_LCLPur !== params.row.New_LCLPur ? "cell-new" : "",
    },
    {
      field: "LCLPUR_ReasonName",
      headerName: "Reason",
      width: 70,
      align: "center",
    },
    {
      field: "Old_MaxStockDays",
      headerName: "Old",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_MaxStockDays !== params.row.New_MaxStockDays
          ? "cell-old"
          : "",
    },
    {
      field: "New_MaxStockDays",
      headerName: "New",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_MaxStockDays !== params.row.New_MaxStockDays
          ? "cell-new"
          : "",
    },
    {
      field: "Old_MinStockDays",
      headerName: "Old",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_MinStockDays !== params.row.New_MinStockDays
          ? "cell-old"
          : "",
    },
    {
      field: "New_MinStockDays",
      headerName: "New",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_MinStockDays !== params.row.New_MinStockDays
          ? "cell-new"
          : "",
    },
    {
      field: "Old_SafetyStockDays",
      headerName: "Old",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_SafetyStockDays !== params.row.New_SafetyStockDays
          ? "cell-old"
          : "",
    },
    {
      field: "New_SafetyStockDays",
      headerName: "New",
      width: 60,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_SafetyStockDays !== params.row.New_SafetyStockDays
          ? "cell-new"
          : "",
    },
  ];

  const allColumns = useMemo(() => {
    return isVisible ? [...baseColumns, ...maxFieldColumns] : baseColumns;
  }, [isVisible, HeadObject?.Head?.A_Status]);

  const columnGroupingModel = [
    {
      groupId: "Discontinued",
      children: [
        { field: "Old_DisContinued" },
        { field: "New_DisContinued" },
        { field: "DisContinue_ReasonName" },
      ],
    },
    {
      groupId: "Active",
      children: [
        { field: "Old_ItActive" },
        { field: "New_ItActive" },
        { field: "Active_ReasonName" },
      ],
    },
    {
      groupId: "DC Discontinued",
      children: [
        { field: "Old_DCDisCon" },
        { field: "New_DCDisCon" },
        { field: "DCDisCon_ReasonName" },
      ],
    },
    {
      groupId: "Central Purchase",
      children: [
        { field: "Old_CNTRLPUR" },
        { field: "New_CNTRLPUR" },
        {
          field: "CNTRLPUR_ReasonName",
        },
      ],
    },
    {
      groupId: "Local Purchase",
      children: [
        { field: "Old_LCLPur" },
        { field: "New_LCLPur" },
        {
          field: "LCLPUR_ReasonName",
        },
      ],
    },
    {
      groupId: "Min Stock Days",
      children: [{ field: "Old_MinStockDays" }, { field: "New_MinStockDays" }],
    },
    {
      groupId: "Safety Stock Days",
      children: [
        { field: "Old_SafetyStockDays" },
        { field: "New_SafetyStockDays" },
      ],
    },
    {
      groupId: "Max Stock Days",
      children: [{ field: "Old_MaxStockDays" }, { field: "New_MaxStockDays" }],
    },
    {
      groupId: "Min Shelf Qty",
      children: [
        { field: "Old_ShelfQty2" },
        { field: "New_ShelfQty2" },
        // {
        //   field: "ShelfQty_ReasonName",
        // },
      ],
    },
    {
      groupId: "Max Shelf Qty",
      children: [
        { field: "Old_ShelfQty" },
        { field: "New_ShelfQty" },
        // {
        //   field: "ShelfQty_Reason",
        // },
      ],
    },
  ];

  //item search
  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
    //   setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  }, [sItemToggleDropdown]);
  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      // "ITEM_SEARCHFULL_GETROW",
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    //status code "" so Success is checked
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet?.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };
  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: bufferObject?.ItemName,
    }));

    if (bufferObject?.ItemName != "") {
      GetSearchItem(
        bufferObject?.ItemName,
        "Any",
        transObj?.A_Location,
        setGridSelectRowData
      );
    }

    handleClick();
  };
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        bufferObject?.ItemName,
        transObj?.A_Location
      );

      if (vItemSearchFull.length > 0) {
        handleItemSelection(
          vItemSearchFull[0]?.ItmCd,
          vItemSearchFull[0]?.Name1
        );
        setItemToggleDropdown(false);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace" && bufferObject?.B_Itmcd) {
      setBufferObj((prev) => ({
        ...prev,
        B_Itmcd: "",
        ItemName: "",
      }));
      setBufferObj((prev) => ({ ...prev, ...initialBufferObj }));
    }
  };
  const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
    let vSeatchVendor = {
      Data: xData,
      Type: xType,
      Loc: xA_Loc,
      v_Vendor: HeadObject?.Head?.VendorCd || "",
      v_isActiveOnly: false,
    };
    const vItemSearch = await fExecuteAPI(
      "SEARCHITEM001_GETROW",
      vSeatchVendor
    );
    if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
      let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(vItemSearchArr);
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch.response.data.message
          ? vItemSearch.response.data.message
          : "Error in SearchItem"
      );
    }
  };
  const fGCToggleItemOnRowClick = async (e) => {
    handleItemSelection(e?.row?.ItmCd, e?.row?.Name1);
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        transObj?.A_Location,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

   const handleExport = () => {
     apiRef.current.exportDataAsCsv({
       getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
       includeHeaders: true,
       utf8WithBom: true,
     });
   };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  return (
    <div className="container-fluid py-2 ">
      <Breadcrumbs />
        <Grid
          container
          spacing={{ xs: 1, md:1.5 }}
          sx={{ alignItems: { xs: "flex-start", sm: "flex-end" },pt:1 }}
        >
          <Grid item xs={3} sm={1.5} md={1} lg={1}>
            <Typography>TransID</Typography>
            <CmpTextFieldEnterV1
              xSize="small"
              xName="Transation ID"
              // xLabelText={""}
              xValue={transObj?.A_Transid}
              xReadOnly={true}
            />
          </Grid>
          <Grid item xs={9} sm={2.5} md={2} lg={1.5}>
            <Typography>Trans Date</Typography>
            <CmpDatePickerField001V1
              xLabelText=""
              xName={"A_Date"}
              xValue={transObj?.A_Date}
              xOnChange={(newValue) => {
                dispatch(Head_Set({ ...transObj, A_Date: newValue.$d }));
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4.5} lg={4.5}>
            <Typography>Location</Typography>
            <FormControl fullWidth>
              <Select
                size="small"
                value={transObj?.A_Location}
                name="A_Location"
                onChange={(e) => {
                  dispatch(
                    Head_Set({ ...transObj, A_Location: e.target.value })
                  );
                }}
              >
                {vRdxuserLoc.map((loc) => (
                  <MenuItem
                    sx={{
                      height: "31px",
                      minHeight: "31px",
                      padding: "0 8px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    key={loc.Uid}
                    value={loc.Uid}
                  >
                    {loc?.Name1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4} md={4.5} lg={3}>
            <Typography>Narration</Typography>
            <TextField
              size="small"
              value={transObj?.A_Narration}
              name="A_Narration"
              InputLabelProps={{
                sx: { color: "primary.main" }, // Sets label color to primary
              }}
              onChange={(e) => {
                dispatch(
                  Head_Set({ ...transObj, A_Narration: e.target.value })
                );
              }}
              fullWidth
              autoComplete="off"
            />
          </Grid>{" "}
          <Grid item xs={12} sm={4} md={2}>
            <Typography>LPO Group</Typography>
            <FormControl fullWidth size="small">
              <Select
                displayEmpty
                value={transObj?.LPOGruppen}
                onChange={(e) =>
                  dispatch(
                    Head_Set({ ...transObj, LPOGruppen: e.target.value })
                  )
                }
                renderValue={(selected) =>
                  selected
                    ? lpoGroupDropDown?.find((x) => x.UId === selected)?.Name1
                    : "Select Reason"
                }
                disabled={HeadObject?.Head?.A_Status?.toUpperCase() !== "ENTER"}
              >
                {lpoGroupDropDown?.map((opt) => (
                  <MenuItem
                    sx={{
                      height: "31px",
                      minHeight: "31px",
                      padding: "0 8px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    key={opt.UId}
                    value={opt.UId}
                  >
                    {opt.Name1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* Item Code */}
          <Grid item xs={4} sm={2} md={1.5} lg={1}>
            <Typography>Item Code</Typography>
            <TextField
              size="small"
              value={bufferObject?.B_Itmcd}
              onChange={(event) =>
                handleDetailChange("B_Itmcd", event.target.value, event)
              }
              fullWidth
              disabled
              autoComplete="off"
            />
          </Grid>
          {/* Item Name */}
          <Grid item xs={8} sm={6} md={3.5} lg={2.5}>
            <Typography>Item Name</Typography>
            <GCToggleSearchV1
              xLabelText=""
              xtabIndex="101"
              xName="B_ItmName"
              xType="text"
              xValue={bufferObject?.ItemName}
              xReadOnly={false}
              xOnChange={(e) => handleDetailChange("ItemName", e.target.value)}
              xOnKeyUp={fItemSearchKey}
              xonClickbtn={fItemSearchKey}
              xrows={sGridSelectRowData}
              xcolumns={[
                { field: "id", headerName: "ID", width: 70, hide: true },
                { field: "ItmCd", headerName: "Code", width: 90 },
                { field: "Name1", headerName: "Name", flex: 1 },
              ]}
              xRowClick={fGCToggleItemOnRowClick}
              xRowCellClick={fGCToggleItemOnCellKeyDown}
              xToggle={sItemToggleDropdown}
              xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
              xOnChangeDropdownInput={fOnChangeItem}
              xDropdownObj={sItemSearchDropdownObj}
              xOnKeyUpDropdownInput={fOnKeyUpItem}
            />
          </Grid>
          {/* Discontinue */}
          <Grid
            item
            xs={6}
            sm={isVisible ? 3 : 2.5}
            md={isVisible ? 2.5 : 2.5}
            lg={2}
          >
            <Box display="flex" gap={1}>
              <FieldGroupComp
                oldLabel="Old Discontinue"
                newLabel="New Discontinue"
                oldComponent={
                  <Checkbox
                    sx={{ p: "1px" }}
                    checked={bufferObject.Old_DisContinued === "Y"}
                    disabled
                  />
                }
                newComponent={
                  <Checkbox
                    sx={{ p: "1px" }}
                    checked={bufferObject.New_DisContinued === "Y"}
                    onChange={(e) =>
                      handleChange(
                        "New_DisContinued",
                        e.target.checked ? "Y" : "N",
                        "checkbox"
                      )
                    }
                  />
                }
                dropDownVisible
                reasonValue={bufferObject.DisContinue_Reason}
                setReasonValue={(value) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    DisContinue_Reason: value,
                  }))
                }
                reasonAttributes={reasonAttributes?.Discontinue}
              />
            </Box>
          </Grid>
          {/* Active */}
          <Grid
            item
            xs={6}
            sm={isVisible ? 3 : 2.5}
            md={isVisible ? 2.5 : 2.5}
            lg={2}
          >
            <Box display="flex" gap={1}>
              <FieldGroupComp
                oldLabel="Old Active"
                newLabel="New Active"
                oldComponent={
                  <Checkbox
                    sx={{ p: "1px" }}
                    checked={bufferObject.Old_ItActive === "Y"}
                    disabled
                  />
                }
                newComponent={
                  <Checkbox
                    sx={{ p: "1px" }}
                    checked={bufferObject.New_ItActive === "Y"}
                    onChange={(e) =>
                      handleChange(
                        "New_ItActive",
                        e.target.checked ? "Y" : "N",
                        "checkbox"
                      )
                    }
                  />
                }
                dropDownVisible
                reasonValue={bufferObject.Active_Reason}
                setReasonValue={(value) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    Active_Reason: value,
                  }))
                }
                reasonAttributes={reasonAttributes?.Active}
              />
            </Box>
          </Grid>
          {/* Conditional Items */}
          {isVisible && (
            <>
              <Grid item xs={12} sm={3} md={4} lg={2.5}>
                <FieldGroupComp
                  oldLabel="Old DC Discontinued"
                  newLabel="New DC Discontinued"
                  oldComponent={
                    <Checkbox
                      sx={{ p: "1px" }}
                      checked={bufferObject.Old_DCDisCon === "Y"}
                      disabled
                    />
                  }
                  newComponent={
                    <Checkbox
                      sx={{ p: "1px" }}
                      checked={bufferObject.New_DCDisCon === "Y"}
                      onChange={(e) =>
                        handleChange(
                          "New_DCDisCon",
                          e.target.checked ? "Y" : "N",
                          "checkbox"
                        )
                      }
                    />
                  }
                  dropDownVisible
                  reasonValue={bufferObject.DCDisCon_Reason}
                  setReasonValue={(value) =>
                    setBufferObj((prev) => ({
                      ...prev,
                      DCDisCon_Reason: value,
                    }))
                  }
                  reasonAttributes={reasonAttributes?.DcDiscon}
                />
              </Grid>
              <Grid item xs={6} sm={3} md={4} lg={2}>
                <FieldGroupComp
                  oldLabel="Old LCL PUR"
                  newLabel="New LCL PUR"
                  oldComponent={
                    <Checkbox
                      sx={{ p: "1px" }}
                      checked={bufferObject.Old_LCLPur === "Y"}
                      disabled
                    />
                  }
                  newComponent={
                    <Checkbox
                      sx={{ p: "1px" }}
                      checked={bufferObject.New_LCLPur === "Y"}
                      onChange={(e) =>
                        handleChange(
                          "New_LCLPur",
                          e.target.checked ? "Y" : "N",
                          "checkbox"
                        )
                      }
                    />
                  }
                  dropDownVisible
                  reasonValue={bufferObject.LCLPur_Reason}
                  setReasonValue={(value) =>
                    setBufferObj((prev) => ({
                      ...prev,
                      LCLPur_Reason: value,
                    }))
                  }
                  reasonAttributes={reasonAttributes?.LocalPur}
                />
              </Grid>
              <Grid item xs={6} sm={3} md={4} lg={2}>
                <FieldGroupComp
                  oldLabel="Old CNTRL PUR"
                  newLabel="New CNTRL PUR"
                  oldComponent={
                    <Checkbox
                      sx={{ p: "1px" }}
                      checked={bufferObject.Old_CNTRLPUR === "Y"}
                      disabled
                    />
                  }
                  newComponent={
                    <Checkbox
                      sx={{ p: "1px" }}
                      checked={bufferObject.New_CNTRLPUR === "Y"}
                      onChange={(e) =>
                        handleChange(
                          "New_CNTRLPUR",
                          e.target.checked ? "Y" : "N",
                          "checkbox"
                        )
                      }
                    />
                  }
                  dropDownVisible
                  reasonValue={bufferObject.CNTRLPUR_Reason}
                  setReasonValue={(value) =>
                    setBufferObj((prev) => ({
                      ...prev,
                      CNTRLPUR_Reason: value,
                    }))
                  }
                  reasonAttributes={reasonAttributes?.CNTLPurchase}
                />
              </Grid>
              <Grid item xs={12} sm={9} md={isVisible ? 7.5 : 7} lg={6.5}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {/* Stock Days Fields */}
                  <FieldGroupComp
                    oldLabel="Old Min Stock Days"
                    newLabel="New Min Stock Days"
                    oldComponent={
                      <TextField
                        value={bufferObject.Old_MinStockDays}
                        InputProps={{ readOnly: true }}
                        variant="outlined"
                        size="small"
                        sx={{
                          width: 60,
                          bgcolor: "lightgray",
                          "& .MuiInputBase-input": {
                            padding: "4px",
                            textAlign: "center",
                          },
                        }}
                      />
                    }
                    newComponent={
                      <TextField
                        value={bufferObject.New_MinStockDays}
                        onChange={(e) =>
                          handleChange("New_MinStockDays", e.target.value)
                        }
                        type="number"
                        variant="outlined"
                        size="small"
                        sx={{
                          width: 60,
                          "& .MuiInputBase-input": {
                            padding: "4px",
                            textAlign: "center",
                          },
                        }}
                      />
                    }
                  />
                  <FieldGroupComp
                    oldLabel="Old Safety Stock Days"
                    newLabel="New Safety Stock Days"
                    oldComponent={
                      <TextField
                        value={bufferObject.Old_SafetyStockDays}
                        InputProps={{ readOnly: true }}
                        variant="outlined"
                        size="small"
                        sx={{
                          width: 60,
                          bgcolor: "lightgray",
                          "& .MuiInputBase-input": {
                            padding: "4px",
                            textAlign: "center",
                          },
                        }}
                      />
                    }
                    newComponent={
                      <TextField
                        value={bufferObject.New_SafetyStockDays}
                        onChange={(e) =>
                          handleChange("New_SafetyStockDays", e.target.value)
                        }
                        type="number"
                        variant="outlined"
                        size="small"
                        sx={{
                          width: 60,
                          "& .MuiInputBase-input": {
                            padding: "4px",
                            textAlign: "center",
                          },
                        }}
                      />
                    }
                  />
                  <FieldGroupComp
                    oldLabel="Old Max Stock Days"
                    newLabel="New Max Stock Days"
                    oldComponent={
                      <TextField
                        value={bufferObject.Old_MaxStockDays}
                        InputProps={{ readOnly: true }}
                        variant="outlined"
                        size="small"
                        sx={{
                          width: 60,
                          bgcolor: "lightgray",
                          "& .MuiInputBase-input": {
                            padding: "4px",
                            textAlign: "center",
                          },
                        }}
                      />
                    }
                    newComponent={
                      <TextField
                        value={bufferObject.New_MaxStockDays}
                        onChange={(e) =>
                          handleChange("New_MaxStockDays", e.target.value)
                        }
                        type="number"
                        variant="outlined"
                        size="small"
                        sx={{
                          width: 60,
                          "& .MuiInputBase-input": {
                            padding: "4px",
                            textAlign: "center",
                          },
                        }}
                      />
                    }
                  />
                </Box>
                {/* Dropdowns for Reasons */}
                <FormControl fullWidth size="small">
                  <Select
                    displayEmpty
                    value={bufferObject.StockDays_Reason || ""}
                    onChange={(e) =>
                      setBufferObj((prev) => ({
                        ...prev,
                        StockDays_Reason: e.target.value,
                      }))
                    }
                    renderValue={(selected) =>
                      selected
                        ? reasonAttributes?.StockDays?.find(
                            (x) => x.UID === selected
                          )?.Name1
                        : "Select Reason"
                    }
                  >
                    {reasonAttributes?.StockDays?.map((opt) => (
                      <MenuItem
                        sx={{
                          height: "31px",
                          minHeight: "31px",
                          padding: "0 8px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        key={opt.UID}
                        value={opt.UID}
                      >
                        {opt.Name1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
          {/* Shelf Qty Fields */}
          <Grid
            item
            xs={12}
            sm={isVisible ? 6.5 : 7}
            md={isVisible ? 4.5 : 7}
            lg={isVisible?3.5:4}
          >
            <Box
              sx={{
                display: "flex",
              }}
            >
              {/* Old Max Shelf Qty */}
              <FieldGroupComp
                oldLabel="Old Max Shelf Qty"
                newLabel="New Max Shelf Qty"
                oldComponent={
                  <TextField
                    value={bufferObject.Old_ShelfQty}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    sx={{
                      width: 60,
                      bgcolor: "lightgray",
                      "& .MuiInputBase-input": {
                        padding: "4px",
                        textAlign: "center",
                      },
                    }}
                  />
                }
                newComponent={
                  <TextField
                    value={bufferObject.New_ShelfQty}
                    onChange={(e) => {
                      let val = e.target.value;
                      if (!/^\d*$/.test(val)) {
                        return;
                      }
                      const num = Number(val);
                      if (num < 0) return;
                      handleChange("New_ShelfQty", val);
                    }}
                    onFocus={(e) => {
                      if (e.target.value === "0") {
                        handleChange("New_ShelfQty", "");
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value === "" || isNaN(e.target.value)) {
                        handleChange("New_ShelfQty", "0");
                      }
                    }}
                    type="text" // ⚠️ change to text to block "-" behavior
                    inputMode="numeric" // mobile: show numeric keyboard
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    sx={{
                      width: 60,
                      "& .MuiInputBase-input": {
                        padding: "4px",
                        textAlign: "center",
                      },
                    }}
                  />
                }
              />
              {/* Old Min Shelf Qty */}
              <FieldGroupComp
                oldLabel="Old Min Shelf Qty"
                newLabel="New Min Shelf Qty"
                oldComponent={
                  <TextField
                    value={bufferObject.Old_ShelfQty2}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    sx={{
                      width: 60,
                      bgcolor: "lightgray",
                      "& .MuiInputBase-input": {
                        padding: "4px",
                        textAlign: "center",
                      },
                    }}
                  />
                }
                newComponent={
                  <TextField
                    value={bufferObject.New_ShelfQty2}
                      onChange={(e) => {
                      let val = e.target.value;
                      if (!/^\d*$/.test(val)) {
                        return;
                      }
                      const num = Number(val);
                      if (num < 0) return;
                      handleChange("New_ShelfQty2", val);
                    }}
                    onFocus={(e) => {
                      if (e.target.value === "0") {
                        handleChange("New_ShelfQty2", "");
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value === "" || isNaN(e.target.value)) {
                        handleChange("New_ShelfQty2", "0");
                      }
                    }}
                    type="text" // ⚠️ change to text to block "-" behavior
                    inputMode="numeric" // mobile: show numeric keyboard
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    sx={{
                      width: 60,
                      "& .MuiInputBase-input": {
                        padding: "4px",
                        textAlign: "center",
                      },
                    }}
                  />
                }
              />
            </Box>
            {/* Dropdown for Shelf Qty Reason */}
            <FormControl fullWidth size="small">
              <Select
                displayEmpty
                value={bufferObject.ShelfQty_Reason || ""}
                onChange={(e) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    ShelfQty_Reason: e.target.value,
                  }))
                }
                renderValue={(selected) =>
                  selected
                    ? reasonAttributes?.ShelfQty?.find(
                        (x) => x.UID === selected
                      )?.Name1
                    : "Select Reason"
                }
              >
                {reasonAttributes?.ShelfQty?.map((opt) => (
                  <MenuItem
                    sx={{
                      height: "31px",
                      minHeight: "31px",
                      padding: "0 8px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    key={opt.UID}
                    value={opt.UID}
                  >
                    {opt.Name1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={isVisible ? 5.5 : 12}
            md={isVisible ? 12 : 5}
            lg={12}
          >
            {/* buttons */}
            <Stack
              direction={"row"}
              sx={{ justifyContent: { xs: "flex-start", lg: "flex-end" } }}
              flexWrap={"wrap"}
              spacing={1}
            >
              <Button
                size="small"
                variant="contained"
                sx={{
                  height: "60%",
                  width: "80px",

                  textTransform: "capitalize",
                  alignItems: "center",
                }}
                onClick={fNewHead}
                disabled={transObj?.A_Status === "POST"}
              >
                New
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={{
                  height: "60%",
                  width: "80px",
                  textTransform: "capitalize",
                  alignItems: "center",
                  ml: 1,
                }}
                onClick={() => {
                  fSave(false, "Saved");
                }}
                disabled={transObj?.A_Status === "POST"}
              >
                Save
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={{
                  height: "60%",
                  width: "80px",
                  textTransform: "capitalize",
                  alignItems: "center",
                  ml: 1,
                }}
                onClick={() => {
                  confirmAlert({
                    title: "Approve",
                    message: "Are you want to Approve ?",
                    buttons: [
                      {
                        className: "alertBtn",
                        label: "Yes",
                        onClick: () => {
                          fSave(true, "Approved");
                        },
                      },
                      {
                        className: "alertBtn",
                        label: "No",
                        onClick: () => "",
                      },
                    ],
                  });
                }}
                disabled={transObj?.A_Status === "POST"}
              >
                Approve
              </Button>
              {HeadObject?.Head?.A_Status_CM?.toUpperCase() === "REJECT" &&
                HeadObject?.Head?.A_Status?.toUpperCase() !== "ENTER" && (
                  <Button
                    size="small"
                    variant="contained"
                    color="error"
                    sx={{
                      height: "60%",
                      width: "80px",
                      textTransform: "capitalize",
                      alignItems: "center",
                      ml: 1,
                    }}
                    onClick={() => {
                      confirmAlert({
                        title: "Reverse Confirmation",
                        message: "Are you sure you want to Reverse?",
                        buttons: [
                          {
                            className: "alertBtn",
                            label: "Yes",
                            onClick: () => {
                              reverseSave();
                            },
                          },
                          {
                            className: "alertBtn",
                            label: "No",
                            onClick: () => "",
                          },
                        ],
                      });
                    }}
                  >
                    Reverse
                  </Button>
                )}
              <Button
                variant="contained"
                size="small"
                sx={{
                  height: "60%",
                  width: "110px",
                  textTransform: "capitalize",
                  alignItems: "center",
                  ml: 1,
                }}
                onClick={() => {
                  setOpen(true);
                }}
                disabled={transObj?.A_Status === "POST"}
              >
                Master Data
              </Button>
              <Tooltip title="Export CSV">
                <IconButton color="primary" onClick={handleExport} size="small">
                  <DownloadOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Print">
                <IconButton color="primary" onClick={handlePrint} size="small">
                  <PrintOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>{" "}
          {/* buttons end Here */}
        </Grid>
        <Box
          sx={{
            marginTop: 1,
            height: {
              xs: "26vh",
              sm: isVisible ? "24vh" : "51vh",
              md: isVisible ? "25vh" : "50vh",
              lg: isVisible ? "39vh" : "54vh",
            },
          }}
        >
          <DataGridPro
            apiRef={apiRef}
            rowHeight={30}
            headerHeight={40}
            hideFooter={true}
            rows={DetailData}
            getRowId={(v) => v.B_Srno}
            columns={allColumns}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            columnGroupingModel={columnGroupingModel}
            experimentalFeatures={{ columnGrouping: true }}
            onRowDoubleClick={(params) => handleRowClick(params.row)}
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
              "& .MuiDataGrid-columnHeader": {
                whiteSpace: "normal",
                lineHeight: "1.2em",
                paddingTop: "8px",
                paddingBottom: "1px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                wordWrap: "break-word",
                fontSize: "11px",
              },
              "& .MuiDataGrid-columnHeaderTitleContainer": {
                textAlign: "center",
                justifyContent: "center",
              },
            }}
          />
        </Box>
      <CycleCustomModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={vMediaQuery}
        title="Filter Modal"
        children={
          <FilterModal
            vMediaQuery={vMediaQuery}
            xMediaQuery={vMediaQuery}
            fLoadDetail={fLoadDetail}
            handleClose={() => setOpen(false)}
          />
        }
      />
    </div>
  );
};

export default StockSetupChangeRequestDetail;
